import React, {type ReactNode, type ComponentProps, useRef} from 'react';

import {type Overlay} from 'react-bootstrap';
import {useTooltipTriggerState} from '@react-stately/tooltip';
import {useTooltipTrigger} from '@react-aria/tooltip';

import {type Placement} from '@react-aria/overlays';

import {Tooltip} from '@time-webkit/all/atoms/tooltip';

import type BootstrapOverlayTrigger from './bootstrap_overlay_trigger';

type Props = Partial<ComponentProps<typeof BootstrapOverlayTrigger>> & Partial<ComponentProps<typeof Overlay>> & {
    disabled?: boolean;
    className?: string;
    children: ReactNode;
    delayHide?: number;
    delayShow?: number;
};

const OverlayTrigger = (props: Props) => {
    const {
        overlay,
        placement = 'top',
        children,
    } = props;

    const targetRef = useRef(null);
    const state = useTooltipTriggerState({delay: 300, closeDelay: 150, defaultOpen: props.defaultOverlayShown});

    const {triggerProps, tooltipProps} = useTooltipTrigger({}, state, targetRef);

    return (
        <>
            {React.cloneElement(children, {...triggerProps, ...children.props, ref: targetRef})}
            {overlay && state.isOpen && (
                <Tooltip
                    {...tooltipProps}
                    placement={placement as Placement}
                    offset={4}
                    className={props.className}
                    state={state}
                    targetRef={targetRef}
                >
                    {React.cloneElement(overlay, {...props.overlayProps, 'data-testid': 'overlay'})}
                </Tooltip>
            )}
        </>
    );
};

OverlayTrigger.displayName = 'OverlayTrigger';

export default OverlayTrigger;
